<template>
  <div class="bg-[#F0FBFB] py-10 md:pt-[120px] md:pb-[100px]">
    <div
      class="flex flex-col md:flex-row w-full md:mx-auto md:max-w-[1140px] md:justify-between md:items-start gap-y-10 md:px-0"
      v-if="!loggedIn"
    >
      <div
        class="flex md:flex-col-reverse md:flex-col flex-row justify-between md:justify-start items-center px-3 md:px-0 gap-y-8 md:gap-x-10"
      >
        <div class="w-full max-w-[160px] md:max-w-[636px]">
          <IconsHelpDesk class="md:w-[636px]" />
        </div>
        <div
          class="w-full max-w-[170px] md:max-w-[406px] md:w-[406px] md:h-[149px] md:bg-white md:shadow-[0px_3px_6px_#00000029] rounded-[7px] text-center flex flex-col items-center justify-center md:px-6 md:pt-[36px] md:pb-[42px]"
        >
          <h2 class="text-sm font-semibold text-space-cadet mb-4">
            {{ $t("orderProcessing.account.preferNoAccount") }}
          </h2>
          <BaseButton
            @click="moveToNextStep"
            variant="outlined"
            class="w-[168px] md:w-[235px] text-[14px] md:text-base font-semibold border-2 border-secondary-2 hover:bg-secondary-2 hover:text-white bg-white transition-colors text-secondary-2 py-2 px-4 rounded"
          >
            {{ $t("orderProcessing.account.continueGuest") }}
          </BaseButton>
        </div>
      </div>

      <div class="w-full flex justify-center md:justify-start md:w-auto">
        <div
          class="border-b border-t grid grid-rows-[auto_1fr] items-start w-full md:border md:shadow-lg md:w-[392px] md:rounded-lg overflow-hidden"
        >
          <div class="flex flex-row [&>a]:flex-1 [&>a:not(:last-of-type)]:border-r">
            <NuxtLinkLocale
              v-for="view in views"
              :key="view.key"
              :locale="switchBlogLocale()"
              @click="currentComponent = view.key"
              class="text-center flex flex-row justify-center text-primary items-center gap-1 border-b p-3 py-4 font-semibold text-sm"
              :class="{
                'bg-white border-b-0 text-secondary': view.active,
              }"
            >
              <Component :is="view.icon" class="shrink-0 w-[1.3em] h-[1.3em]" />
              <span class="text-black">{{ view.label }}</span>
            </NuxtLinkLocale>
          </div>
          <div
            v-for="view in views"
            :key="view.key"
            class="bg-white p-3 max-w-full overflow-auto"
            :id="view.key"
            :class="{ hidden: !view.active }"
          >
            <Component :is="view.component" v-if="view.active" :enableRedirect="false" />
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="loggedIn"
      class="flex flex-col max-w-lg border-2 border-secondary-2 rounded bg-white p-5 ml-4 mr-4 md:mx-auto"
    >
      <div class="flex justify-center w-full py-1">
        <div class="flex flex-col space-y-3 text-center">
          <div>
            <p class="text-sm font-semibold">{{ $t("orderProcessing.account.loggedInMessage") }}</p>
            <p class="text-sm font-semibold">{{ $t("orderProcessing.account.continueCheckout") }}</p>
          </div>
          <BaseButton
            @click="logout(false)"
            variant="outlined"
            class="w-full text-sm font-semibold border-2 border-secondary-2 transition-colors text-secondary-2 py-2 px-4 rounded"
          >
            {{ $t("orderProcessing.account.logout") }}
          </BaseButton>
        </div>
      </div>
    </div>

    <div v-if="loggedIn" class="flex flex-col max-w-lg ml-4 mr-4 mt-3 md:mx-auto">
      <BaseButton
        @click="moveToNextStep"
        class="w-full text-sm font-semibold transition-colors text-secondary-2 py-2 px-4 rounded"
      >
        {{ $t("orderProcessing.account.continueOrder") }}
      </BaseButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import EditIcon from "~/components/icons/EditIcon.vue";
import LoggedInUser from "~/components/icons/LoggedInUser.vue";

import Login from "~/pages/account/[page]/public/views/login.vue";
import Signup from "~/pages/account/[page]/public/views/signup.vue";

const emit = defineEmits(["userLoggedIn", "moveToNextStep"]);

const currentComponent = ref("login");
const bus = useNuxtApp().$bus as any;
const { t } = useI18n();

const views = computed(() => [
  {
    key: "login",
    get active() {
      return currentComponent.value === this.key;
    },
    component: Login,
    icon: LoggedInUser,
    label: t("orderProcessing.account.login"),
  },
  {
    key: "signup",
    get active() {
      return currentComponent.value === this.key;
    },
    component: Signup,
    icon: EditIcon,
    label: t("orderProcessing.account.createAccount"),
  },
]);

const profileStore = useProfileStore();
const { loggedIn } = toRefs(profileStore);
// await useAsyncData("user-profile", () => profileStore.fetchProfile());

bus.on("user-logged-in", async () => {
  setTimeout(async () => {
    await profileStore.fetchProfile();
    if (loggedIn.value == true) {
      emit("userLoggedIn", true);
    }
  }, 1000);
});

bus.on("user-logged-out", () => {
  profileStore.resetState();
});

const moveToNextStep = () => {
  emit("moveToNextStep", true);
};
</script>
